// возможно следует перенести в entities
export const currencySymbols = Object.freeze({
  /**
   Lek
   */
  ALL: 'L',
  '008': 'L',
  /**
   Algerian Dinar 
   */
  DZD: 'DA',
  '012': 'DA',
  /**
   Argentine Peso
  */
  ARS: '$',
  '032': '$',
  /**
   Australian Dollar 
  */
  AUD: '$',
  '036': '$',
  /**
   Bahamian Dollar
   */
  BSD: 'B$',
  '044': 'B$',
  /**
   Bahraini Dinar
   */
  BHD: 'BD',
  '048': 'BD',
  /**
   Taka 
   */
  BDT: '৳',
  '050': '৳',
  /**
   Armenian Dram
   */
  AMD: '֏',
  '051': '֏',
  /**
   Barbados Dollar 
   */
  BBD: 'Bds$',
  '052': 'Bds$',
  /**
   Bermudian Dollar
   */
  BMD: '$',
  '060': '$',
  /**
   Ngultrum 
   */
  BTN: 'Nu',
  '064': 'Nu',
  /**
   Boliviano 
   */
  BOB: 'Bs',
  '068': 'Bs',
  /**
   Pula
   */
  BWP: 'P',
  '072': 'P',
  /**
   Belize Dollar 
   */
  BZD: 'Bz$',
  '084': 'Bz$',
  /**
   Solomon Islands Dollar
   */
  SBD: '$',
  '090': '$',
  /**
   Brunei Dollar
   */
  BND: '$',
  '096': '$',
  /**
   Kyat 
   */
  MMK: 'K',
  '104': 'K',
  /**
   Burundi Franc
   */
  BIF: 'FBu',
  '108': 'FBu',
  /**
   Riel
   */
  KHR: '៛',
  '116': '៛',
  /**
   Canadian Dollar
   */
  CAD: '$',
  '124': '$',
  /**
   Cabo Verde Escudo
   */
  CVE: '$',
  '132': '$',
  /** 
   Cayman Islands Dollar
   */
  KYD: '$',
  '136': '$',
  /**
   Sri Lanka Rupee 
   */
  LKR: 'Rs',
  '144': 'Rs',
  /**
   Chilean Peso
   */
  CLP: '$',
  '152': '$',
  /**
   China Yuan
   */
  CNY: '¥',
  '156': '¥',
  /**
   Colombian Peso
   */
  COP: 'COL$',
  '170': 'COL$',
  /**
   Comorian Franc
   */
  KMF: '₣',
  '174': '₣',
  /**
   Costa Rican Colon
   */
  CRC: '₡',
  '188': '₡',
  /**
   Kuna
   */
  HRK: 'Kn',
  '191': 'Kn',
  /**
   Cuban Peso
   */
  CUP: '$',
  '192': '$',
  /**
   Czech Koruna
   */
  CZK: 'Kč',
  '203': 'Kč',
  /**
   Danish Krone
   */
  DKK: 'kr.',
  '208': 'kr.',
  /**
   Dominican Peso
   */
  DOP: 'RD$',
  '214': 'RD$',
  /**
   El Salvador Colon
   */
  SVC: '₡',
  '222': '₡',
  /**
   Ethiopian Birr
   */
  ETB: 'Br',
  '230': 'Br',
  /**
   Nakfa 
   */
  ERN: 'Nfk',
  '232': 'Nfk',
  /**
   Falkland Islands Pound 
   */
  FKP: 'FK£',
  '238': 'FK£',
  /**
   Fiji Dollar 
   */
  FJD: '$',
  '242': '$',
  /**
   Djibouti Franc
   */
  DJF: '₣',
  '262': '₣',
  /**
   Dalasi
   */
  GMD: 'D',
  '270': 'D',
  /**
   Gibraltar Pound 
   */
  GIP: '£',
  '292': '£',
  /**
   Quetzal
   */
  GTQ: 'Q',
  '320': 'Q',
  /**
   Guinean Franc
   */
  GNF: '₣',
  '324': '₣',
  /**
   Guyana Dollar
   */
  GYD: 'G$',
  '328': 'G$',
  /**
   Gourde
   */
  HTG: 'G',
  '332': 'G',
  /**
   Lempira
   */
  HNL: 'L',
  '340': 'L',
  /**
   Hong Kong Dollar
   */
  HKD: 'HK$',
  '344': 'HK$',
  /**
   Forint 
   */
  HUF: 'ƒ',
  '348': 'ƒ',
  /**
   Iceland Krona
   */
  ISK: 'kr',
  '352': 'kr',
  /**
   Indian Rupee
   */
  INR: '₹',
  '356': '₹',
  /**
   Rupiah
   */
  IDR: 'Rp',
  '360': 'Rp',
  /**
   Iranian Rial
   */
  IRR: '﷼',
  '364': '﷼',
  /**
   Iraqi Dinar
   */
  IQD: 'د.ع',
  '368': 'د.ع',
  /**
   New Israeli Sheqel
   */
  ILS: '₪',
  '376': '₪',
  /**
   Jamaican Dollar
   */
  JMD: 'J$',
  '388': 'J$',
  /**
   Japanese Yen
   */
  JPY: '¥',
  '392': '¥',
  /**
   Tenge
   */
  KZT: '₸',
  '398': '₸',
  /**
   Jordanian Dinar 
   */
  JOD: 'JD',
  '400': 'JD',
  /**
   Kenyan Shilling
   */
  KES: 'KSh',
  '404': 'KSh',
  /**
   North Korean Won
   */
  KPW: '₩',
  '408': '₩',
  /**
   South Korean Won
   */
  KRW: '₩',
  '410': '₩',
  /**
   Kuwaiti Dinar
   */
  KWD: 'د.ك',
  '414': 'د.ك',
  /**
   Som
   */
  KGS: 'c',
  '417': 'c',
  /**
   Lao Kip
   */
  LAK: '₭',
  '418': '₭',
  /**
   Lebanese Pound
   */
  LBP: '.ل.ل',
  '422': '.ل.ل',
  /**
   Loti 
   */
  LSL: 'L',
  '426': 'L',
  /**
   Liberian Dollar
   */
  LRD: 'Lib$',
  '430': 'Lib$',
  /**
   Libyan Dinar
   */
  LYD: '.د.ل',
  '434': '.د.ل',
  /**
   Pataca 
   */
  MOP: 'MOP$',
  '446': 'MOP$',
  /**
   Malawi Kwacha
   */
  MWK: 'MK',
  '454': 'MK',
  /**
   Malaysian Ringgit 
   */
  MYR: 'RM',
  '458': 'RM',
  /**
   Rufiyaa
   */
  MVR: 'Rf',
  '462': 'Rf',
  /**
   Mauritius Rupee
   */
  MUR: '₨',
  '480': '₨',
  /**
   Mexican peso
   */
  MXN: '$',
  '484': '$',
  /**
   Tugrik
   */
  MNT: '₮',
  '496': '₮',
  /**
   Moldovan leu
   */
  MDL: 'L',
  '498': 'L',
  /**
   Moroccan Dirham
  */
  MAD: 'DH',
  '504': 'DH',
  /**
   Rial Omani
   */
  OMR: 'OMR',
  '512': 'OMR',
  /**
   Namibia Dollar 
   */
  NAD: 'N$',
  '516': 'N$',
  /**
   Nepalese Rupee
   */
  NPR: 'N₨',
  '524': 'N₨',
  /**
   Netherlands Antillean Guilder 
   */
  ANG: 'ƒ',
  '532': 'ƒ',
  /**
   Aruban Florin
   */
  AWG: 'Afl',
  '533': 'Afl',
  /**
   Vatu
   */
  VUV: 'Vt',
  '548': 'Vt',
  /**
   New Zealand Dollar 
   */
  NZD: '$',
  '554': '$',
  /**
   Cordoba Oro
   */
  NIO: 'C$',
  '558': 'C$',
  /**
   Nigerian Naira
   */
  NGN: '₦',
  '566': '₦',
  /**
   Norwegian Krone 
   */
  NOK: 'kr',
  '578': 'kr',
  /**
   Pakistan Rupee
   */
  PKR: '₨',
  '586': '₨',
  /**
   Balboa
   */
  PAB: 'B/.',
  '590': 'B/.',
  /**
   Kina
   */
  PGK: 'K',
  '598': 'K',
  /**
   Guarani
   */
  PYG: '₲',
  '600': '₲',
  /**
   Sol
   */
  PEN: 'S/.',
  '604': 'S/.',
  /**
   Philippine Peso
   */
  PHP: '₱',
  '608': '₱',
  /**
   Qatari Rial 
   */
  QAR: 'QR',
  '634': 'QR',
  /**
   Russian ruble
   */
  RUB: '₽',
  RUR: '₽',
  '643': '₽',
  /**
   Rwanda Franc
   */
  RWF: 'FRw',
  '646': 'FRw',
  /**
   Saint Helena Pound
   */
  SHP: '£',
  '654': '£',
  /**
   Saudi Riyal
    */
  SAR: 'SR',
  '682': 'SR',
  /**
   Seychelles Rupee
   */
  SCR: 'SRe',
  '690': 'SRe',
  /**
   Leone
   */
  SLL: 'Le',
  '694': 'Le',
  /**
   Singapore Dollar
   */
  SGD: '$',
  '702': '$',
  /**
   Vietnamese Dong
   */
  VND: '₫',
  '704': '₫',
  /**
   Somali Shilling 
   */
  SOS: 'Sh.So',
  '706': 'Sh.So',
  /**
   Rand
   */
  ZAR: 'R',
  '710': 'R',
  /**
   South Sudanese Pound
   */
  SSP: 'Db',
  '728': 'Db',
  /**
   Lilangeni (pl. Emalangeni) 
   */
  SZL: 'E',
  '748': 'E',
  /**
   Swedish Krona
   */
  SEK: 'kr',
  '752': 'kr',
  /**
   Swiss Franc
   */
  CHF: '₣',
  '756': '₣',
  /**
   Syrian Pound
   */
  SYP: 'LS',
  '760': 'LS',
  /**
   Thai Baht
   */
  THB: '฿',
  '764': '฿',
  /**
   Pa’anga
   */
  TOP: '$',
  '776': '$',
  /**
   Trinidad and Tobago Dollar
   */
  TTD: 'TT$',
  '780': 'TT$',
  /**
   UAE Dirham
   */
  AED: 'AED',
  '784': 'AED',
  /**
   Tunisian Dinar
   */
  TND: 'DT',
  '788': 'DT',
  /**
   Uganda Shilling
   */
  UGX: 'Ush',
  '800': 'Ush',
  /**
   Denar
   */
  MKD: 'DEN',
  '807': 'DEN',
  /**
   Egyptian Pound
   */
  EGP: '.ج.م',
  '818': '.ج.م',
  /**
   British Pound Sterling
   */
  GBP: '£',
  '826': '£',
  /**
   Tanzanian Shilling
   */
  TZS: 'TSh',
  '834': 'TSh',
  /**
   US Dollar
   */
  USD: '$',
  '840': '$',
  /**
   Peso Uruguayo
   */
  UYU: '$U',
  '858': '$U',
  /**
   Uzbek Sum
   */
  UZS: "So'm",
  '860': "So'm",
  /**
   Tala
   */
  WST: '$',
  '882': '$',
  /**
   Yemeni Rial
   */
  YER: '.ر.ي',
  '886': '.ر.ي',
  /**
   New Taiwan Dollar
   */
  TWD: 'NT$',
  '901': 'NT$',
  /**
   Leone
   */
  SLE: 'Le',
  '925': 'Le',
  /**
   Bolívar Soberano
   */
  VED: 'Bs.S.',
  '926': 'Bs.S.',
  /**
   Bolívar Soberano
   */
  VES: 'Bs.S.',
  '928': 'Bs.S.',
  /**
   Ouguiya
   */
  MRU: 'UM',
  '929': 'UM',
  /**
   Dobra
   */
  STN: '₡',
  '930': '₡',
  /**
   Peso Convertible 
   */
  CUC: 'CUC$',
  '931': 'CUC$',
  /**
   Zimbabwe Dollar
   */
  ZWL: '$',
  '932': '$',
  /**
   Belarusian Ruble
   */
  BYN: 'Br',
  '933': 'Br',
  /**
   Turkmenistan New Manat
   */
  TMT: 'T',
  '934': 'T',
  /**
   Ghana Cedi
   */
  GHS: 'GH₵',
  '936': 'GH₵',
  /**
   Sudanese Pound 
   */
  SDG: 'ج.س',
  '938': 'ج.س',
  /**
   Uruguay Peso en Unidades Indexadas
   */
  UYI: '$U',
  '940': '$U',
  /**
   Serbian Dinar
   */
  RSD: 'din',
  '941': 'din',
  /**
   Mozambique Metical
   */
  MZN: 'MT',
  '943': 'MT',
  /**
   Azerbaijani Manat
   */
  AZN: '₼',
  '944': '₼',
  /**
   Romanian Leu
   */
  RON: 'lei',
  '946': 'lei',
  /**
   Turkish Lira
   */
  TRY: '₺',
  '949': '₺',
  /**
   CFA Franc BEAC
   */
  XAF: '₣',
  '950': '₣',
  /**
   East Caribbean Dollar 
   */
  XCD: 'EC$',
  '951': 'EC$',
  /**
   CFA Franc BCEAO 
   */
  XOF: '₣',
  '952': '₣',
  /**
   CFP Franc
   */
  XPF: '₣',
  '953': '₣',
  /**
   SDR (Special Drawing Rights)
   */
  XDR: 'XDR',
  '960': 'XDR',
  /**
   Zambian Kwacha 
   */
  ZMW: 'K',
  '967': 'K',
  /**
   Surinam Dollar
   */
  SRD: '$',
  '968': '$',
  /**
   Malagasy Ariary
   */
  MGA: 'Ar.',
  '969': 'Ar.',
  /**
   Unidad de Valor Real
   */
  COU: 'COU',
  '970': 'COU',
  /**
   Afghani
   */
  AFN: 'Afs',
  '971': 'Afs',
  /**
   Tajik Somoni
   */
  TJS: 'c',
  '972': 'c',
  /**
   Kwanza 
   */
  AOA: 'Kz',
  '973': 'Kz',
  /**
   Bulgarian Lev
   */
  BGN: 'лв.',
  '975': 'лв.',
  /**
   Congolese Franc
   */
  CDF: '₣',
  '976': '₣',
  /**
   Convertible Mark
   */
  BAM: 'KM',
  '977': 'KM',
  /**
   Euro
   */
  EUR: '€',
  '978': '€',
  /**
   Ukrainian Hryvnia
   */
  UAH: '₴',
  '980': '₴',
  /**
   Lari
   */
  GEL: '₾',
  '981': '₾',
  /**
   Polish Zloty
   */
  PLN: 'zł',
  '985': 'zł',
  /**
   Brazilian Real 
   */
  BRL: 'R$',
  '986': 'R$',
} as const)

export type CurrencySymbolsType = keyof typeof currencySymbols
